import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Actualiza el state para mostrar la UI de error
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log del error
        console.error('ErrorBoundary caught an error:', error, errorInfo);
        
        this.setState({
            error: error,
            errorInfo: errorInfo
        });

        // Opcional: enviar el error a un servicio de logging
        // logErrorToService(error, errorInfo);
    }

    handleReload = () => {
        // Limpiar cache y recargar
        if ('caches' in window) {
            caches.keys().then(names => {
                names.forEach(name => {
                    caches.delete(name);
                });
            });
        }
        
        // Limpiar localStorage y sessionStorage
        localStorage.clear();
        sessionStorage.clear();
        
        // Recargar la página
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    padding: '20px',
                    backgroundColor: '#f8f9fa',
                    fontFamily: 'Arial, sans-serif'
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        padding: '40px',
                        borderRadius: '10px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        textAlign: 'center',
                        maxWidth: '500px',
                        width: '100%'
                    }}>
                        <h1 style={{
                            color: '#dc3545',
                            marginBottom: '20px',
                            fontSize: '24px'
                        }}>
                            ¡Oops! Algo salió mal
                        </h1>
                        
                        <p style={{
                            color: '#6c757d',
                            marginBottom: '30px',
                            lineHeight: '1.5'
                        }}>
                            Ha ocurrido un error inesperado. Esto puede deberse a una versión antigua de la aplicación en tu navegador.
                        </p>
                        
                        <button
                            onClick={this.handleReload}
                            style={{
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                padding: '12px 24px',
                                borderRadius: '5px',
                                fontSize: '16px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s'
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
                        >
                            Recargar Aplicación
                        </button>
                        
                        <p style={{
                            fontSize: '12px',
                            color: '#6c757d',
                            marginTop: '20px'
                        }}>
                            Esto limpiará el cache y recargará la aplicación con la versión más reciente.
                        </p>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
